var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-icon"},[_c('svg',{attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"4","y":"4","width":"16","height":"16","rx":"5","fill":"#F4DB64"}}),_c('path',{attrs:{"x":"4","y":"4","d":"M 7 12 h 10","stroke":"#2F2F2F","stroke-width":"2"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }